import type { CSSProperties } from 'react';

/** Zajedničke mjere desktop tablica (header + retci kao flex s fiksnim širinama stupaca). */

/** Razmak između stupaca — CSS token `--table-col-gap` u global.css. */
export const TABLE_COL_GAP = 16;

/** Stupac sa StatusPill-om, pill centriran. */
export const TABLE_STATUS_COL_WIDTH = 100;

/** Stupac s datumom (dd/mm/yyyy) i kratkom oznakom u headeru (npr. „DATUM SLANJA”, 10px). */
export const TABLE_DATE_COL_WIDTH = 84;

/** Stupac s oznakom tjedna („Tjedan 43 (19.10.–25.10.)”) — lomi se u dva retka. */
export const TABLE_WEEK_COL_WIDTH = 160;

/** Stupac s oznakom tjedna kao glavnim podatkom retka (13.5px, podebljano) — top-level liste. */
export const TABLE_WEEK_PRIMARY_COL_WIDTH = 180;

/** Stupac s rasponom tjedana (npr. „48/2026 — 12/2027”, 13px). */
export const TABLE_WEEK_RANGE_COL_WIDTH = 120;

/** Stupac sa šifrom/brojem dokumenta (npr. kod radnog paketa). */
export const TABLE_CODE_COL_WIDTH = 100;

/** Stupac sa šifrom objekta (kratke šifre, npr. „S.574”). */
export const TABLE_OBJECT_CODE_COL_WIDTH = 70;

/** Stupac sa šifrom stavke cjenika (npr. „EL-001”). */
export const TABLE_ITEM_CODE_COL_WIDTH = 50;

/** Stupac s nazivom objekta (npr. „S. 574 MBV 2”); duži nazivi se skraćuju s „…”. */
export const TABLE_OBJECT_COL_WIDTH = 130;

/** Stupac s kebab gumbom (RowActionsMenu), gumb centriran. */
export const TABLE_ACTION_COL_WIDTH = 32;

/** Stupac s tekstualnim linkom umjesto kebab gumba („Detalji”), centriran. */
export const TABLE_LINK_ACTION_COL_WIDTH = 60;

/** Minimalna širina tablice: stupci + razmaci između njih + vanjski padding retka. */
export const tableMinWidth = (columnWidths: number[], horizontalPadding = 24) =>
  columnWidths.reduce((sum, width) => sum + width, 0) +
  (columnWidths.length - 1) * TABLE_COL_GAP +
  horizontalPadding * 2;

/** Header redak tablice dobiva i `className="table-header-row"` — oznake stupaca uvijek u jednom retku (global.css). */

/** Header i retci tablice — isti razmak među stupcima u oba. */
export const tableRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'var(--table-col-gap)'
};

/** Centrirani sadržaj ćelije (status, akcija); širi sadržaj se prelijeva jednako na obje strane. */
export const tableCenteredCellStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  whiteSpace: 'nowrap'
};

let measureContext: CanvasRenderingContext2D | null | undefined;

/** Širina stupca prema najduljem tekstu u njemu, ograničena na [min, max]. */
export const fitColumnWidth = (texts: string[], font: string, min: number, max: number) => {
  measureContext ??= document.createElement('canvas').getContext('2d');
  const ctx = measureContext;
  if (!ctx) return max;
  ctx.font = `${font} ${getComputedStyle(document.body).fontFamily}`;
  const longest = Math.max(0, ...texts.map((text) => ctx.measureText(text).width));
  return Math.min(max, Math.max(min, Math.ceil(longest) + 1));
};
